import type { ResponseZone } from '../types/simulation';

export const responseZones: Record<
  ResponseZone,
  { label: string; tendency: string; short: string; relation: string; textClass: string; tintClass: string }
> = {
  under: {
    label: 'Under-response',
    tendency: 'Lower response tendency',
    short: 'Lower',
    relation: 'Below the target response window',
    textClass: 'text-under',
    tintClass: 'bg-under-tint',
  },
  target: {
    label: 'Target response',
    tendency: 'Target response tendency',
    short: 'Target',
    relation: 'Within the target response window',
    textClass: 'text-target',
    tintClass: 'bg-target-tint',
  },
  over: {
    label: 'Over-response',
    tendency: 'Higher / excessive response tendency',
    short: 'Higher',
    relation: 'Above the target response window',
    textClass: 'text-over',
    tintClass: 'bg-over-tint',
  },
};
